export const GoogleMapApiConfig = 'AIzaSyDiVS8tWc4GBOAbNMG1b-3E_3FEJBWYBGw';